var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbsUpOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.667 2.5L12.0503 2.89167C12.1579 2.99927 12.258 3.11224 12.351 3.23019C12.5173 3.44106 12.6607 3.66784 12.7837 3.90833C12.867 4.075 12.892 4.275 12.8503 4.45833L12.0837 8.33333H16.667C17.5837 8.33333 18.3337 9.08333 18.3337 10V10.9C18.3337 11.1333 18.2837 11.3583 18.192 11.5667L15.967 16.6917C15.667 17.1917 15.1253 17.5 14.5337 17.5H7.78366C6.9891 17.5 6.30381 17.022 6.00033 16.3385C5.89321 16.0973 5.83366 15.8304 5.83366 15.55V9.025C5.83366 8.86791 5.8558 8.71293 5.89857 8.56418C5.97607 8.29472 6.12129 8.0457 6.32533 7.84167L11.667 2.5ZM11.6373 3.94394L7.03243 8.54877C6.90305 8.67816 6.83366 8.84891 6.83366 9.025V15.55C6.83366 16.0727 7.26094 16.5 7.78366 16.5H14.5337C14.7572 16.5 14.9588 16.3929 15.0817 16.2197L17.2767 11.1639C17.315 11.0769 17.3337 10.9886 17.3337 10.9V10C17.3337 9.63562 17.0314 9.33333 16.667 9.33333H10.8664L11.8616 4.30314C11.7937 4.17651 11.719 4.05679 11.6373 3.94394ZM4.85396 8.69638C4.70338 8.47753 4.45121 8.33333 4.16699 8.33333H1.66699V17.5H4.16699C4.62533 17.5 5.00033 17.125 5.00033 16.6667V9.16667C5.00033 9.11841 4.99617 9.07107 4.98819 9.025C4.9674 8.90485 4.92064 8.7933 4.85396 8.69638ZM2.66699 16.5H4.00033V9.33333H2.66699V16.5Z",
    fill: "#5B5C5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUpOff);
export default __webpack_public_path__ + "static/media/ThumbsUpOff.6038edf98e4349762b55921cb321bf6d.svg";
export { ForwardRef as ReactComponent };